module.exports = [{
      plugin: require('/Users/James/Repositories/gatsby-lego/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/James/Repositories/gatsby-lego/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
